import { CompletePerson } from '@/app/models/person';
import { usePaymentWithoutSharingQuery } from '@/app/services/personApi';
import PageTitle from '@/components/common/pageTitle';
import { usePeriod } from '@/components/context/PeriodContext';
import NewCreateSharingScreen from '@/components/noSharing/newCreateSharingScreen';
import NoSharingTable from '@/components/noSharing/noSharingTable';
import PeriodDetails from '@/components/periodDetails/PeriodDetails';
import { Drawer } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

function NoSharing() {
  const { t } = useTranslation(['noSharing', 'common']);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(5);
  const [searchTerm, setSearchTerm] = useState('');

  const { selectedPeriod } = usePeriod();

  const { data } = usePaymentWithoutSharingQuery(selectedPeriod?.date as string);

  const [drawerStatus, setDrawerStatus] = useState(false);
  const [selectedItem, setSelectedItem] = useState<CompletePerson | null>(null);

  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        marginRight: '20px',
      }}
    >
      <PeriodDetails />
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <PageTitle title={t('no.sharing')} subtitle={t('no.sharing.subtitle') as string} />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '20%',
            margin: '0',
          }}
        />
      </div>

      <NoSharingTable
        rows={data || []}
        setDrawerStatus={setDrawerStatus}
        setSelectedItem={setSelectedItem}
      />

      <Drawer
        anchor="right"
        open={drawerStatus}
        onClose={(event: React.SyntheticEvent, reason: string) => {
          setDrawerStatus(false);
        }}
      >
        <NewCreateSharingScreen selectedPerson={selectedItem} setDrawerOpen={setDrawerStatus} />
      </Drawer>
    </div>
  );
}
export default NoSharing;
